<template>
  <page-view :menu="menu">
    <template #header>
      <base-header :title="'Configurações'" />
    </template>
    <template #content>
      <v-row no-gutters v-if="!hasFetchSubscription">
        <loading-logo :value="200" />
      </v-row>
      <v-row no-gutters v-else>
        <invoice-details />
        <customer-billing />
        <add-payment-modal />
        <billing-date />
        <v-col cols="12">
          <v-row align="center" no-gutters>
            <span class="pageTitle"> {{ $t('message.plan') }} </span>
          </v-row>
        </v-col>
        <template v-if="!userPlanInfo.subscription">
          <v-col cols="12" class="mt-7">
            <v-row align="start" no-gutters>
              <v-card
                color="#e6e8f8"
                class="rounded-pill px-3 py-1 mr-6 mt-1"
                flat
              >
                <span class="userPlanText">
                  {{ $t('message.pages.userPlan.noPlan') }}
                </span>
              </v-card>
              <v-spacer />
              <v-btn
                v-if="isRootUser || hasEditPlanPerm"
                class="mt-1"
                color="primary"
                elevation-0
                @click="handlePlansPage"
              >
                {{ $t('message.pages.userPlan.changePlan') }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-8">
            <v-divider />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12" class="mt-7">
            <v-row align="start" no-gutters>
              <v-card
                v-if="userPlanInfo"
                color="#e6e8f8"
                class="rounded-pill px-3 py-1 mr-6 mt-1"
                flat
              >
                <span class="userPlanText">
                  {{ userPlanInfo.subscription.name }}
                </span>
              </v-card>
              <span class="priceParagraph">
                <span class="planPrice textType--text">
                  {{
                    (
                      userPlanInfo.subscription.unit_amount / 100
                    ).toLocaleString(currencyLocale, {
                      style: 'currency',
                      currency: currency,
                    })
                  }}/mês
                </span>
                <br />
                <span
                  v-if="
                    userPlanInfo.subscription.current_period_end &&
                    prorateTotalValue
                  "
                  class="subtitlePlanPrice textType--text"
                >
                  {{
                    `${$t('message.pages.userPlan.planWillRenew')} ${new Date(
                      userPlanInfo.subscription.current_period_end * 1000
                    ).toLocaleDateString('pt-BR')}, ${$t(
                      'message.pages.userPlan.planWillRenew2'
                    )} ${
                      prorateTotalValue &&
                      prorateTotalValue.toLocaleString(currencyLocale, {
                        style: 'currency',
                        currency: currency,
                      })
                    }.`
                  }}
                </span>
              </span>
              <v-spacer />
              <div
                v-if="isRootUser || hasEditPlanPerm"
                class="container__plan-btns"
              >
                <v-btn
                  color="primary"
                  outlined
                  elevation-0
                  class="mr-3 mt-1"
                  :disabled="loadings.fetchData"
                  @click="handleActualPayment"
                >
                  {{ $t('message.paymentDetails') }}
                </v-btn>
                <v-btn
                  class="mt-1"
                  color="primary"
                  elevation-0
                  @click="handlePlansPage"
                >
                  {{ $t('message.pages.userPlan.changePlan') }}
                </v-btn>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-8">
            <v-divider />
          </v-col>
          <v-col cols="12" class="mt-8">
            <v-row no-gutters>
              <v-col cols="4">
                <span class="categoriesTitle">{{
                  $t('message.benefits')
                }}</span>
              </v-col>
              <v-col cols="8">
                <v-row no-gutters class="flex-column" justify="center">
                  <span
                    v-for="(benefit, i) in planBenefits"
                    :key="i"
                    class="benefitsText mt-2"
                    :class="benefit.type ? 'textType2--text' : 'textType--text'"
                  >
                    <v-icon
                      v-if="benefit.type"
                      color="lightenText"
                      size="16"
                      class="mr-2 mb-1"
                      @click="handleAddAddons"
                    >
                      mdi-plus-circle-outline
                    </v-icon>
                    <v-icon
                      v-else
                      color="lightenText"
                      size="16"
                      class="mr-2 mb-1"
                    >
                      mdi-check-circle
                    </v-icon>
                    <span
                      v-if="benefit.type"
                      class="benefitsText"
                      v-html="benefit.text"
                    ></span>
                    <span v-else class="benefitsText" v-html="benefit"></span>
                    <br />
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </template>
        <v-col cols="12" :class="userPlanInfo.subscription ? 'mt-12' : 'mt-8'">
          <v-row no-gutters>
            <v-col cols="4">
              <span class="categoriesTitle">{{
                $t('message.pages.userPlan.paymentForm')
              }}</span>
            </v-col>
            <v-col cols="8" class="my-auto">
              <v-row no-gutters>
                <v-col cols="12" v-if="getCardsLoading">
                  <loading-logo :value="150" />
                </v-col>
                <v-col cols="12" v-else>
                  <span class="creditCardText">
                    <v-row
                      v-for="(payment, i) in userSources"
                      no-gutters
                      :key="i"
                      class="mb-3"
                      align="center"
                    >
                      <v-col>
                        <v-row no-gutters>
                          <v-card
                            width="100%"
                            flat
                            class="d-flex flex-row align-center justify-space-between container__payment-method"
                          >
                            <v-card flat>
                              <v-row no-gutters>
                                <template v-if="payment.type === 'boleto'">
                                  <v-card
                                    style="padding-left: 2px"
                                    outlined
                                    width="35"
                                    height="24"
                                    class="rounded card-image d-flex align-center justify-center"
                                  >
                                    <v-img
                                      src="@/assets/boletoIcon.svg"
                                      max-width="24"
                                    />
                                  </v-card>
                                  <span class="pl-2 paymentLabel">
                                    {{ $t('message.pages.userPlan.ticket') }}
                                  </span>
                                </template>
                                <template v-else>
                                  <img
                                    :src="
                                      cardsImages[
                                        `${payment.brand.toLowerCase()}`
                                      ]
                                    "
                                    width="35"
                                    class="rounded card-image"
                                  />
                                  <span class="pl-2 paymentLabel">
                                    {{
                                      capitalizeFirstLetter(payment.brand)
                                    }}-{{ payment.last4 }}
                                  </span>
                                </template>
                                <v-card
                                  v-if="payment.default"
                                  width="64"
                                  color="#EBEDFF"
                                  class="rounded-pill px-2 py-0 ml-2"
                                  flat
                                >
                                  <span
                                    class="text--center dataTitle"
                                    :style="'color: #1E2977'"
                                  >
                                    Padrão
                                  </span>
                                </v-card>
                                <v-card
                                  flat
                                  v-else
                                  width="64"
                                  class="ml-2"
                                ></v-card>

                                <div v-if="isRootUser" class="show-mobile">
                                  <v-progress-circular
                                    v-if="
                                      beingEditedCard === payment.id &&
                                      editingCardLoading
                                    "
                                    class="mb-1 ml-3"
                                    :size="16"
                                    width="2"
                                    color="gray"
                                    indeterminate
                                  />

                                  <PaymentMethodOptions
                                    v-else
                                    :disabled="editingCardLoading"
                                    :payment="payment"
                                    @changeDefaultPayment="changeDefaultPayment"
                                    @handleDeleteCard="handleDeleteCard"
                                  />
                                </div>
                              </v-row>
                            </v-card>
                            <v-card class="d-flex flex-row" flat>
                              <span v-if="payment.type === 'boleto'">
                                {{ payment.tax_id }}
                              </span>
                              <span v-else>
                                {{ $t('message.pages.userPlan.expiresIn') }}
                                {{ payment.exp_month }}/{{ payment.exp_year }}
                              </span>
                              <v-card
                                v-if="isRootUser"
                                width="28"
                                height="28"
                                flat
                                class="d-flex flex-row align-center justify-center ml-2 mr-2 hide-mobile"
                              >
                                <v-progress-circular
                                  v-if="
                                    beingEditedCard === payment.id &&
                                    editingCardLoading
                                  "
                                  class="mb-1 ml-3"
                                  :size="16"
                                  width="2"
                                  color="gray"
                                  indeterminate
                                />
                                <PaymentMethodOptions
                                  :disabled="editingCardLoading"
                                  v-else
                                  :payment="payment"
                                  @changeDefaultPayment="changeDefaultPayment"
                                  @handleDeleteCard="handleDeleteCard"
                                />
                              </v-card>
                            </v-card>
                          </v-card>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-col
                      v-if="errors.deleteUnknownError"
                      cols="12"
                      class="px-0"
                    >
                      <v-card flat height="30">
                        <span
                          class="red--text footerText align-text d-block my-1"
                          style="font-size: 13px"
                        >
                          {{ errors.deleteShownErrMsg }}
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon size="18" v-bind="attrs" v-on="on">
                                mdi-help-circle
                              </v-icon>
                            </template>
                            <v-container
                              class="text-body-2 pa-0"
                              style="max-width: 230px"
                            >
                              {{ errors.deleteErrMsg }}
                            </v-container>
                          </v-tooltip>
                        </span>
                      </v-card>
                    </v-col>
                    <v-col
                      cols="12"
                      class="pa-0"
                      v-if="isRootUser && userSources.length"
                    >
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pa-0"
                      v-if="isRootUser"
                      :class="{
                        'mt-2': userSources.length,
                        'text-end': !userSources.length,
                      }"
                    >
                      <span
                        class="addPaymentText"
                        style="cursor: pointer"
                        @click="handleOpenPaymentMethod"
                      >
                        {{ $t('message.pages.userPlan.addPaymentForm') }}
                      </span>
                    </v-col>
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-12" v-if="userPlanInfo.subscription">
          <v-row no-gutters>
            <v-col cols="4">
              <span class="categoriesTitle">
                {{ $t('message.pages.userPlan.paymentClosure') }}
              </span>
            </v-col>
            <v-col cols="7">
              <v-row no-gutters class="flex-column" justify="center">
                <v-col cols="12" class="mb-4">
                  <span class="dataTitle textType--text">
                    <b>{{ $t('message.pages.userPlan.monthDay') }}</b> <br />
                  </span>
                  <span
                    class="dataText textType2--text"
                    v-if="userPlanInfo.subscription.billing_cycle_anchor"
                  >
                    {{
                      new Date(
                        userPlanInfo.subscription.billing_cycle_anchor * 1000
                      )
                        .getDate()
                        .toString()
                        .padStart(2, '0')
                    }}
                  </span>
                  <span
                    v-if="
                      userPlanInfo.schedule_update_due_date &&
                      userPlanInfo.schedule_update_due_date.new_due_date
                    "
                    style="font-size: 14px"
                    class="mb-1"
                  >
                    <v-icon class="px-2" size="16">mdi-arrow-right</v-icon>
                    {{
                      userPlanInfo.schedule_update_due_date.new_due_date.slice(
                        -2
                      )
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    userPlanInfo.schedule_update_due_date &&
                    userPlanInfo.schedule_update_due_date.new_due_date
                  "
                >
                  <v-alert color="var(--v-brand-lighten1)" class="py-2">
                    <v-icon class="mr-2" color="#0F21A1">
                      mdi-information
                    </v-icon>
                    <span style="color: #0b134a" class="subtitlePlanPrice">
                      {{ $t('message.pages.userPlan.nextPaymentInfo') }} ({{
                        getNextDayMonth()
                      }})
                    </span>
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="d-flex flex-row justify-end pt-2">
              <span>
                <span
                  v-if="isRootUser"
                  class="settingsText primary--text"
                  style="cursor: pointer"
                  @click="handleBillingDateModal"
                  >{{ $t('message.actions.change') }}</span
                >
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-12">
          <v-row no-gutters>
            <v-col cols="4">
              <span class="categoriesTitle">{{
                $t('message.pages.userPlan.billingData')
              }}</span>
            </v-col>
            <v-col cols="7">
              <v-row no-gutters class="flex-column" justify="center">
                <v-col
                  v-for="(info, i) in billingData"
                  :key="i"
                  cols="12"
                  class="mb-4"
                >
                  <span class="dataTitle textType--text">
                    <b>{{ info.title }}</b> <br />
                  </span>
                  <span
                    class="dataText textType2--text"
                    v-for="(text, i) in info.info"
                    :key="i"
                  >
                    {{ text }} <br />
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="d-flex flex-row justify-end pt-2">
              <span>
                <span
                  v-if="isRootUser"
                  class="settingsText primary--text"
                  style="cursor: pointer"
                  @click="handleCustomerModal"
                  >{{ $t('message.actions.change') }}</span
                >
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-12">
          <v-row no-gutters>
            <v-col
              :cols="isMobileBreakpoint ? '12' : '4'"
              :class="isMobileBreakpoint ? 'mb-4' : ''"
            >
              <span class="categoriesTitle">{{
                $t('message.pages.userPlan.billingDates')
              }}</span>
            </v-col>
            <v-col
              :cols="isMobileBreakpoint ? '12' : '8'"
              class="container__billing-history"
            >
              <v-row v-if="userPlanInfo.has_open_dispute" no-gutters>
                <v-col cols="12">
                  <v-alert dense color="#ffcdd3" width="100%">
                    <v-row no-gutters class="align-center justify-start">
                      <v-col
                        cols="1"
                        class="mr-2 d-flex flex-row align-start justify-center"
                      >
                        <v-icon color="#b71d1c">mdi-alert</v-icon>
                      </v-col>
                      <v-col>
                        <span
                          v-html="
                            $t('message.pages.userPlan.paymentDisputeIssue')
                          "
                          class="footerText align-text d-block"
                          style="color: #c43c3e"
                        >
                        </span>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row no-gutters class="dataTitle textType--text">
                <v-col cols="2">
                  <span :class="isMobileBreakpoint ? 'paymentItem' : ''">{{
                    $t('message.pages.userPlan.date')
                  }}</span>
                </v-col>
                <v-col v-if="!isMobileBreakpoint" cols="3">
                  <span :class="isMobileBreakpoint ? 'paymentItem' : ''">{{
                    $t('message.pages.userPlan.description')
                  }}</span>
                </v-col>
                <v-col :cols="isMobileBreakpoint ? '3' : '2'">
                  <span :class="isMobileBreakpoint ? 'paymentItem' : ''">{{
                    $t('message.pages.userPlan.value')
                  }}</span>
                </v-col>
                <v-col :cols="isMobileBreakpoint ? '4' : '3'">
                  <span :class="isMobileBreakpoint ? 'paymentItem' : ''">{{
                    $t('message.pages.userPlan.situation')
                  }}</span>
                </v-col>
              </v-row>

              <v-row no-gutters v-if="loadings.fetchData">
                <v-col cols="12">
                  <v-skeleton-loader
                    class="fixSkeletonLoader"
                    type="table-tbody"
                  />
                </v-col>
              </v-row>

              <v-row
                v-else
                v-for="(payment, i) in shownInvoices"
                :key="i"
                no-gutters
                class="textType2--text"
              >
                <template v-if="payment.status !== 'void'">
                  <v-col cols="12" class="py-2">
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="2"
                    :class="isMobileBreakpoint ? 'paymentItem' : ''"
                  >
                    <span>
                      {{ formatDate(payment.created) }}
                    </span>
                  </v-col>
                  <v-col cols="3" v-if="!isMobileBreakpoint">
                    <span
                      >{{ prefixDescription(payment.description) }}
                      {{ payment.description }}</span
                    >
                  </v-col>
                  <v-col
                    v-if="payment.status !== 'open'"
                    :cols="isMobileBreakpoint ? '3' : '2'"
                  >
                    <span>
                      {{
                        (payment.amount_paid / 100).toLocaleString(
                          currencyLocale,
                          {
                            style: 'currency',
                            currency: currency,
                          }
                        )
                      }}</span
                    >
                  </v-col>
                  <v-col
                    v-if="payment.status === 'open'"
                    :cols="isMobileBreakpoint ? '3' : '2'"
                  >
                    <span>
                      {{
                        (payment.total / 100).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                      }}</span
                    >
                  </v-col>
                  <v-col :cols="isMobileBreakpoint ? '4' : '3'">
                    <v-row no-gutters class="statusText">
                      <v-tooltip top v-if="payment.refunded.length">
                        <template v-slot:activator="{ on, attrs }">
                          <v-card
                            color="#e4e6ec"
                            class="rounded-lg px-2 py-1"
                            flat
                            v-bind="attrs"
                            v-on="on"
                          >
                            <span
                              v-if="checkIfIsPartialRefund(payment)"
                              class="text--center"
                              :style="'color: #525768'"
                            >
                              {{ $t('message.pages.userPlan.partialRefund') }}
                              <v-icon color="#657083" size="17">
                                mdi-information-variant-box-outline
                              </v-icon>
                            </span>
                            <span
                              v-else
                              class="text--center"
                              :style="'color: #525768'"
                            >
                              {{ $t('message.pages.userPlan.refunded') }}
                              <v-icon color="#657083" size="17">
                                mdi-arrow-u-left-top
                              </v-icon>
                            </span>
                          </v-card>
                        </template>
                        <span>{{
                          checkIfIsPartialRefund(payment)
                            ? `${getRefundedValue(payment)} ${$t(
                                'message.pages.userPlan.wasRefunded'
                              )}`
                            : $t('message.pages.userPlan.completeRefund')
                        }}</span>
                      </v-tooltip>
                      <v-card
                        v-else-if="payment.status === 'paid'"
                        color="#C8E6C9"
                        class="rounded-pill px-2 py-1"
                        flat
                      >
                        <span class="text--center" :style="'color: #1B5E20'">
                          {{ $t('message.pages.userPlan.paid').toUpperCase() }}
                        </span>
                      </v-card>
                      <v-card
                        v-else
                        color="#FFECB3"
                        class="rounded-pill px-2 py-1"
                        flat
                      >
                        <span class="text--center" :style="'color: #585D83'">
                          {{
                            $t('message.pages.userPlan.pending').toUpperCase()
                          }}
                        </span>
                      </v-card>
                    </v-row>
                  </v-col>
                  <v-col cols="2" class="d-flex flex-row justify-end pr-3">
                    <v-icon
                      color="primary"
                      class="mr-1"
                      :disabled="!payment.invoice_pdf"
                      @click="openLink(payment.invoice_pdf)"
                    >
                      mdi-file-document-outline
                    </v-icon>
                    <v-img
                      v-if="payment.has_nfe"
                      src="@/assets/nfeEnabled.svg"
                      max-width="24"
                      style="cursor: pointer"
                      @click="downloadNfe(payment.id)"
                    ></v-img>
                  </v-col>
                </template>
              </v-row>
              <v-col cols="12" class="py-2 px-0">
                <v-divider />
              </v-col>
            </v-col>
            <v-col
              cols="12"
              class="mt-3"
              v-if="!allInvoicesShown && payments.length > 4"
            >
              <v-row no-gutters align="end" justify="end">
                <span
                  class="primary--text paymentTitle"
                  style="cursor: pointer"
                  @click="showAllInvoices"
                >
                  {{ $t('message.pages.userPlan.showMore') }}
                </span>
              </v-row>
            </v-col>
          </v-row>
          <form
            ref="downloadForm"
            method="post"
            :action="downloadUrl"
            style="display: none"
          >
            <input
              ref="downloadInput"
              name="Authorization"
              :value="authToken"
              type="hidden"
            />
          </form>
        </v-col>
      </v-row>
    </template>
  </page-view>
</template>

<script>
// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
import i18n from '@/translations/lang'

// API
import invoiceApi from '@/services/invoiceApi'
import planApi from '@/services/planApi'
import addressApi from '@/services/addressApi'

// Components
import InvoiceDetails from './InvoiceDetails.vue'
import AddPaymentModal from './AddPaymentModal.vue'
import CustomerBilling from './CustomerBilling.vue'
import BillingDate from './BillingDate.vue'
import LoadingLogo from '@/components/LoadingLogo.vue'
import PaymentMethodOptions from './PaymentMethodOptions.vue'

import PageView from '@/layout/PageView.vue'
import { mapMutations, mapState } from 'vuex'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import Storage from '@/utils/Storage'
import store from '@/store'
import axios from 'axios'

export default {
  name: 'UserPlan',
  mixins: [calcMegabytesMixin, linkHelper],
  components: {
    LoadingLogo,
    InvoiceDetails,
    PageView,
    CustomerBilling,
    BillingDate,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
    AddPaymentModal,
    PaymentMethodOptions,
  },
  data: () => ({
    payments: [],
    reducedPayments: [],
    loadings: {
      fetchData: false,
    },
    errors: {
      fetchData: false,
      deleteUnknownError: false,
      deleteShownErrMsg: '',
      deleteErrMsg: '',
    },
    allInvoicesShown: false,
    currency: 'brl',
    currencyLocale: 'pt-BR',
    cardErrors: {
      declined: false,
      default: false,
      expired: false,
    },
    defaultSource: {},
    userSources: [],
    cardsLoading: false,
    addCardLoading: false,
    editingCardLoading: false,
    getCardsLoading: true,
    newCard: false,
    beingEditedCard: '',
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
    boletoUrl: '',
    invoiceId: '',
    authToken: '',
    prorateResponse: {},
    prorateTotalValue: null,
    isBeta: false,
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      planInfo: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    userPaymentDate() {
      if (this.userPlanInfo.schedule_update_due_date) {
        return this.userPlanInfo.schedule_update_due_date?.new_due_date.slice(
          -2
        )
      } else {
        return new Date(
          this.userPlanInfo.subscription.billing_cycle_anchor * 1000
        ).getDate()
      }
    },
    downloadUrl() {
      // if (ENV_CONFIG !== 'production') {
      //   return `https://api-v2-staging.pandavideo.com/stripe/invoices?invoice_id=${this.invoiceId}&download_nfe=1`
      // }
      // return `https://api-v2.pandavideo.com/stripe/invoices?invoice_id=${this.invoiceId}&download_nfe=1`
      return 'https://api-v2.pandavideo.com/stripe/invoices?invoice_id=in_1N6HwfA9gXMNgQ3rsoIDQPYC&download_nfe=1'
    },
    planBenefits() {
      let traffic = this.calcMegabytes(
        this.userPlanInfo.subscription?.metadata?.transfer,
        'GB',
        'GB',
        true
      )
      let storage = this.calcMegabytes(
        this.userPlanInfo.subscription?.metadata?.storage,
        'GB',
        'GB',
        true
      )
      let benefitsArray = [
        `<b>${storage}</b> ${this.$i18next.t('message.pages.Cart.ofStorage')}`,
        `<b>${traffic}</b> ${this.$i18next.t(
          'message.pages.Cart.ofTrafficPerMonth'
        )}`,
        `${this.$i18next.t('message.pages.Cart.billedInReal')}`,
        `${this.$i18next.t('message.pages.userPlan.playerCustom')}`,
        'Analytics',
      ]
      if (this.userPlanInfo?.addons?.storage) {
        let storageTypeVal
        this.userPlanInfo.addons?.storage[0]?.quantity > 512
          ? (storageTypeVal = 'TB')
          : (storageTypeVal = 'GB')
        let addicionalStorage = this.calcMegabytes(
          this.userPlanInfo.addons?.storage[0]?.quantity,
          'GB',
          storageTypeVal,
          true
        )
        benefitsArray.push({
          type: 'addon',
          text: `<b>${addicionalStorage}</b> ${this.$i18next.t(
            'message.pages.Cart.ofStorage'
          )} ${this.$i18next.t('message.pages.userPlan.addicional')}`,
        })
      }
      if (this.userPlanInfo?.addons?.traffic) {
        let trafficTypeVal
        this.userPlanInfo.addons?.traffic[0]?.quantity > 512
          ? (trafficTypeVal = 'TB')
          : (trafficTypeVal = 'GB')
        let addicionalTraffic = this.calcMegabytes(
          this.userPlanInfo.addons?.traffic[0]?.quantity,
          'GB',
          trafficTypeVal,
          true
        )
        benefitsArray.push({
          type: 'addon',
          text: `<b>${addicionalTraffic}</b> ${this.$i18next.t(
            'message.pages.userPlan.ofMonthlyTraffic'
          )} ${this.$i18next.t('message.pages.userPlan.addicional')}`,
        })
      }
      return benefitsArray
    },
    isRootUser() {
      return this.$store.state.user?.userAllInfo?.is_root ?? false
    },
    hasEditPlanPerm() {
      return (
        (this.$store.state.user.userPermissions?.includes('post-plan') &&
          this.$store.state.user.userPermissions?.includes('put-plan')) ??
        false
      )
    },
    shownInvoices() {
      if (this.allInvoicesShown) {
        return this.payments
      } else {
        return this.reducedPayments
      }
    },
    hasFetchSubscription() {
      return !!this.userPlanInfo.user
    },
    billingData() {
      let infos = []
      if (!this.userPlanInfo) return []
      if (this.userPlanInfo.user.name) {
        infos.push({
          title: i18n.t('message.pages.profile.name'),
          info: [`${this.userPlanInfo.user.name ?? '-'}`],
        })
      }
      if (this.userPlanInfo.address) {
        infos.push({
          title: i18n.t('message.pages.profile.billingAddress'),
          info: [
            `${this.userPlanInfo.address.line1 ?? '-'}`,
            `${this.userPlanInfo.address.city ?? '-'}`,
            `${this.userPlanInfo.address.postal_code ?? '-'}`,
            `${this.userPlanInfo.address.country ?? '-'}`,
          ],
        })
      }
      if (this.userPlanInfo.user.phone) {
        infos.push({
          title: i18n.t('message.pages.profile.phone'),
          info: [`${this.userPlanInfo.user.phone ?? '-'}`],
        })
      }
      if (this.userPlanInfo.taxId) {
        infos.push({
          title: i18n.t('message.pages.profile.document'),
          info: [`${this.userPlanInfo.taxId.value ?? '-'}`],
        })
      }
      return infos
    },
    menu() {
      return this.$store.state.user.settingsNavItems
    },
  },
  async mounted() {
    this.isBeta = location.search.match('beta')
    this.getCountries()
    this.fetchInvoices()
    this.setCurrencyConfig()
    this.getThisCycleInfoWithProrate()
    await this.getCards()
    this.authToken = Storage.getItem('accessToken')
    this.isRootuser && this.getChangeCardUrl()
    this.$root.$on('updateSources', (sources) => {
      this.userSources = JSON.parse(JSON.stringify(sources))
    })
  },
  watch: {
    userPlanInfo: {
      handler() {
        this.handleSnackbar()
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_ONLY_CUSTOMIZING',
      'UPDATE_GLOBAL_SNACKBAR',
    ]),
    handleSnackbar() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.pages.profile.updatedInfo'),
      })
    },
    checkIfIsPartialRefund(invoice) {
      const totalAmount = invoice.refunded.reduce(
        (sum, refund) => sum + refund.amount,
        0
      )
      return totalAmount < invoice.amount_due
    },
    getRefundedValue(invoice) {
      const totalAmount = invoice.refunded.reduce(
        (sum, refund) => sum + refund.amount,
        0
      )
      return (totalAmount / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: this.planInfo.currency,
      })
    },
    async getThisCycleInfoWithProrate() {
      let items = []
      try {
        let ret = await planApi.previewInvoice(
          this.userPlanInfo.subscription_id,
          this.getLocale().toLowerCase(),
          items
        )
        this.prorateResponse = ret.data
        this.prorateTotalValue = ret.data.amount_due / 100
      } catch (error) {
        console.error('error', error)
      }
    },
    async downloadVideo() {
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      this.$refs.downloadForm.submit()
    },
    async getCards() {
      this.clearErrors()
      this.getCardsLoading = true
      try {
        const { data } = await planApi.getCards()
        this.userSources = data.sources
        const card = data.sources.find((item) => item.default === true)
        this.defaultSource = card
        this.getCardsLoading = false
      } catch (error) {
        this.getCardsLoading = false
        console.error('error', error)
      }
    },
    async changeDefaultPayment(payment) {
      this.clearErrors()
      this.beingEditedCard = payment.id
      this.editingCardLoading = true
      try {
        let ret = await planApi.changeDefaultCard(payment.id)
        this.defaultSource = payment
        this.userSources = ret.data.sources
        this.editingCardLoading = false
      } catch (e) {
        this.handleFetchError(e)
        this.editingCardLoading = false
        this.errors.cardInfoError = true
      }
      this.beingEditedCard = ''
    },
    async handleDeleteCard(card) {
      this.clearErrors()
      this.editingCardLoading = true
      this.beingEditedCard = card.id
      try {
        await planApi.deleteCard(card.id)
        this.userSources = this.userSources.filter((item) => item.id != card.id)
        this.editingCardLoading = false
      } catch (e) {
        this.handleFetchError(e)
        this.loadingFetch = false
        this.editingCardLoading = false
      }
      this.beingEditedCard = ''
    },
    prefixDescription(desc) {
      const isPlan = ['bronze', 'silver', 'gold'].includes(desc.toLowerCase())
      return isPlan ? this.$i18next.t('message.plan') : ''
    },
    handleFetchError(err) {
      this.errors.deleteShownErrMsg = i18n.t('message.errors.unexpectedError')
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.deleteUnknownError = true
      this.errors.deleteErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
      if (err?.response?.data?.detail?.raw?.message) {
        this.errors.deleteErrMsg = err.response.data.detail.raw.message
      }
    },
    async getChangeCardUrl() {
      if (this.userPlanInfo.type_payment === 'boleto') {
        const retBoletoUrl = await planApi.getBoletoUrl(
          location.href,
          location.href,
          'pt-BR'
        )
        this.boletoUrl = retBoletoUrl.data.url
      }
    },
    handleAddAddons() {
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
    async getCountries() {
      let storageCountries = Storage.getItem('countries')
      if (storageCountries?.length) return
      try {
        const { data } = await addressApi.getCountries()
        Storage.setItem('countries', data.countries)
      } catch (error) {
        console.error('error', error)
      }
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    async downloadNfe(invoiceId) {
      const res = await axios.get(
        `https://api-v2.pandavideo.com/stripe/invoices?invoice_id=${invoiceId}&download_nfe=1`,
        {
          headers: {
            Authorization: `Bearer ${Storage.getItem('accessToken')}`,
            Accept: 'application/pdf',
          },
          responseType: 'blob',
        }
      )
      window.open(
        URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
      )
    },
    handleActualPayment() {
      this.$root.$emit('openInvoiceDetails', this.prorateResponse)
    },
    openLink(link) {
      return window.open(`${link}`, '_blank')
    },
    handlePlansPage() {
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.$router.push({ name: 'Cart' })
      this.$root.$emit('isChangingPlan', true)
      this.handleClose()
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    handleCustomerModal() {
      this.$root.$emit('customerBillingModal')
    },
    handleBillingDateModal() {
      const isTrial = this.planInfo.subscription.status === 'trialing'

      if (isTrial) this.$root.$emit('ModalResetBillingCycle')
      else this.$root.$emit('openBillingDate', this.defaultSource)
    },
    handleOpenPaymentMethod() {
      this.$root.$emit('openAddPaymentModal')
    },
    async fetchInvoices() {
      this.loadings.fetchData = true
      try {
        let ret = await invoiceApi.getInvoices()
        this.payments = JSON.parse(JSON.stringify(ret.data.invoices))
        this.reducedPayments = JSON.parse(
          JSON.stringify(ret.data.invoices.splice(0, 5))
        )
        this.loadings.fetchData = false
      } catch (e) {
        this.loadings.fetchData = false
        console.log('e', e)
      }
    },
    showAllInvoices() {
      const isTrial = this.planInfo.subscription.status === 'trialing'

      if (isTrial) this.$root.$emit('ModalResetBillingCycle')
      else this.allInvoicesShown = true
    },
    handleInvoiceRowClick(invoice) {
      this.$root.$emit('openInvoiceDetails', invoice)
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => {
        if (typeof e === 'string') e = ''
        if (typeof e === Boolean) e = false
      })
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000)

      // Get day, month and year
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString()

      // Format the date string
      const formattedDate = `${day}/${month}/${year}`

      return formattedDate
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    getNextDayMonth() {
      // const day =
      //   Number(
      //     this.userPlanInfo.schedule_update_due_date?.new_due_date.slice(-2)
      //   ) ?? 0
      // const currentDate = new Date()
      // // const currentMonth = currentDate.getMonth()
      // const currentYear = currentDate.getFullYear()
      // let nextMonthDate = new Date(currentYear, 11, day)
      // if (day < currentDate.getDate()) {
      //   nextMonthDate = new Date(currentYear, 11, day)
      // }
      // const formattedNextMonthDate = `${nextMonthDate
      //   .getDate()
      //   .toString()
      //   .padStart(2, '0')}/${
      //   nextMonthDate.getMonth().toString().padStart(2, '0') + `/${currentYear}`
      // }`
      // return formattedNextMonthDate

      const selectedDay =
        Number(
          this.userPlanInfo.schedule_update_due_date?.new_due_date.slice(-2)
        ) ?? 0
      const currentDate = new Date()
      const currentDay = currentDate.getDate()
      const currentMonth = currentDate.getMonth()
      const currentYear = currentDate.getFullYear()

      // Check if the selected day is in the current month or next month
      const nextMonth = (currentMonth + 1) % 12
      const selectedMonth = selectedDay < currentDay ? nextMonth : currentMonth

      // Calculate the expected billing date
      const expectedDate = new Date(
        currentYear + (selectedMonth < currentMonth ? 1 : 0),
        selectedMonth,
        selectedDay
      )
      return `${expectedDate.getDate().toString().padStart(2, '0')}/${(
        expectedDate.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}/${expectedDate.getFullYear()}`
    },
  },
}
</script>

<style lang="scss">
.container__billing-history {
  width: 100%;
  overflow-x: auto;

  > div {
    width: 100%;
    min-width: 430px;
  }
}

.pageTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: var(--v-brand-darken2);
}

.planPrice {
  font-weight: 500;
  font-size: 18px;
}

.benefitsText {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
}

.categoriesTitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: var(--v-brand-darken2);

  @media only screen and (max-width: 960px) {
    font-size: 13px;
  }
}

.subtitlePlanPrice {
  font-weight: 400;
  font-size: 14px;
}

.priceParagraph {
  line-height: 20px;
}

.benefitsText {
  font-weight: 400;
  font-size: 16px;
}

.creditCardText {
  font-weight: 400;
  font-size: 16px;
}

.paymentTitle {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}

.paymentItem {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;

  @media only screen and (max-width: 960px) {
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}

.statusText {
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
}

.fixSkeletonLoader .v-skeleton-loader__table-tbody {
  padding: 0px;
  margin: 0px;
}

.userPlanText {
  font-weight: 500;
  font-size: 18px;
  color: var(--v-brand-darken1);
}

.dataTitle {
  font-weight: 500;
  font-size: 14px;
}

.dataText {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: var(--v-textType2);
}

.settingsText {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}

.linkText {
  font-style: normal;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.05em;
  color: var(--v-primary-base);
}

.addPaymentText {
  font-size: 14px;
  font-weight: 500;
  color: var(--v-primary-base);
}

.bg-dark,
.theme--dark {
  .pageTitle,
  .categoriesTitle {
    color: #8fb1e3;
  }

  .userPlanText {
    color: #70a5f2;
  }
}

.show-mobile {
  display: none !important;
}

@media only screen and (max-width: 653px) {
  .container__plan-btns {
    margin-top: 16px;
  }
}

@media only screen and (max-width: 612px) {
  .v-application .flex-row.container__payment-method {
    flex-direction: column !important;
    align-items: start !important;

    > .v-card:last-child {
      margin-top: 10px;
    }

    .hide-mobile {
      display: none !important;
    }

    .show-mobile {
      display: block !important;
    }
  }
}

@media only screen and (max-width: 560px) {
  .priceParagraph {
    margin-top: 18px;
  }
}

@media only screen and (max-width: 466px) {
  .container__plan-btns button:last-child {
    margin-top: 10px !important;
  }
}

@media only screen and (max-width: 406px) {
  .card-image {
    display: none !important;
  }

  .v-application .pl-2.paymentLabel {
    padding-left: 0 !important;
  }
}
</style>
